import apiClient from './apiClient';

export type PublicReportPoint = {
    value: number;
    photo?: number | null;
    marker?: string | null;
    sdnn?: number | string;
    rmssd?: number | string;
    pnn20?: number | string;
    pnn50?: number | string;
};

export type PublicReportUser = {
    id?: number;
    first_name?: string | null;
    last_name?: string | null;
    middle_name?: string | null;
    email?: string | null;
    age?: number | null;
    weight?: number | null;
    height?: number | null;
    gender?: number | null;
};

export type PublicReportResponse = {
    points: PublicReportPoint[];
    user: PublicReportUser;
    reportMeta: {
        created_at?: string | null;
        testName?: string | null;
    };
};

const reportsService = {
    getById: async (reportId: number, ownerUserId?: number) => {
        const q = new URLSearchParams({ id: String(reportId) });
        if (ownerUserId != null && ownerUserId > 0) q.set('userId', String(ownerUserId));
        return apiClient.get(`/reports/byId?${q.toString()}`);
    },
    getPoints: async (payload: { value: string; pin?: string | null; withFilter?: boolean }) =>
        apiClient.post<PublicReportResponse>('/reports/get', payload),
    getAll: async (id?: number, page = 0, pageSize = 10) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (id != null && id > 0) q.set('userId', String(id));
        return apiClient.get(`/reports/getAllPaginated?${q.toString()}`);
    },
    getAllAdmin: async (id?: number, page = 0, pageSize = 10) => {
        const q = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
        if (id != null && id > 0) q.set('userId', String(id));
        return apiClient.get(`/reports/getAllAdminPaginated?${q.toString()}`);
    },
    postComment: async (payload : any) => await apiClient.post('/reports/comment', payload),
    delete: async (payload : any) => await apiClient.delete('/reports/delete', {
        data: payload,
    }),
    getFile: async (payload : any, config = {}) => await apiClient.post('/reports/getFile', payload, {
        ...config,
        responseType: 'blob'
    }),
    getFileByUserId: async (payload : any, config = {}) => await apiClient.post('/reports/getFileByUserId', payload, {
        ...config,
        responseType: 'blob'
    }),

    getReportProperties: async (reportId: number) => {
        const res = await apiClient.get<{
            properties?: Array<Record<string, unknown>>;
            report?: unknown;
        }>(`/reports/getProperty?id=${reportId}`);
        const properties = (res.data?.properties ?? []).map((p) => ({
            id: (p.id ?? p.property_id) as number | undefined,
            name: String(p.name ?? p.property_name ?? ''),
            value: String(p.value ?? p.property_value ?? ''),
            description: (p.description ?? p.property_description ?? null) as string | null,
            timestamp: (p.timestamp ?? p.property_timestamp ?? null) as number | string | null,
            created_at: (p.created_at ?? p.property_created_at) as string | undefined,
        }));
        return { ...res.data, properties };
    },

};

export default reportsService;
